import { render } from "./MessengerAccounts.vue?vue&type=template&id=d7a10bf2&scoped=true"
import script from "./MessengerAccounts.vue?vue&type=script&lang=js"
export * from "./MessengerAccounts.vue?vue&type=script&lang=js"

import "./MessengerAccounts.vue?vue&type=style&index=0&id=d7a10bf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a10bf2"]])

export default __exports__